import React, { useState } from "react"
import PropTypes from "prop-types"
import moment from "moment"
import MomentPropTypes from "react-moment-proptypes"
import { Column } from "react-virtualized"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import DataTable from "@swipesense/data-table"
import CaseBanner from "../CaseBanner"
import Loading from "../Loading"
import "./EmployeeCaseUserVisitList.scss"
require("moment-duration-format") // not called directly, but extends moment to add moment.duration()

const EmployeeCaseUserVisitList = (props) => {
  const [modal, setModal] = useState(props.modalOpen)

  const closeButton = (
    <button
      className="close-button fa fa-times"
      type="button"
      title="button"
      onClick={() => setModal(!modal)}
    />
  )

  const nameCellRenderer = (props) => {
    return (
      <div className="nameCell">
        <div className="name">{props.cellData}</div>
        <div className="subName">{props.rowData.unit}</div>
      </div>
    )
  }

  nameCellRenderer.propTypes = {
    cellData: PropTypes.string,
    rowData: PropTypes.object,
  }

  const visitCellRenderer = (props) => {
    const visitDate = moment.parseZone(props.rowData.entryAt)
    const duration = moment.duration(props.rowData.duration, "seconds")
    return (
      <div className="visit">
        <div className="date">{visitDate.format("MMM D")}</div>
        <div className="dot-divider">•</div>
        <div className="time">{visitDate.format("h:mm a").slice(0, -1)}</div>
        <div className="duration">{duration.format("(h[h] m[m])")}</div>
      </div>
    )
  }

  visitCellRenderer.propTypes = {
    rowData: PropTypes.object,
  }

  return (
    <div className="EmployeeCaseUserVisitList">
      <button onClick={() => setModal(!modal)}>
        <i className="fa fa-history" /> View Visit History
      </button>
      <Modal
        isOpen={modal}
        size={"lg"}
        centered={true}
        className={"EmployeeCaseUserVisitList"}
      >
        <ModalHeader close={closeButton}>
          <div className="hidden">History</div>
        </ModalHeader>
        <ModalBody>
          <CaseBanner
            caseId={props.caseId}
            employeeName={props.name}
            employeeId={props.employeeId}
            role={props.role}
            department={props.department}
            compliance={props.compliance}
          />
          <div className="visits-wrapper">
            <DataTable
              className="employee-case-user-visit-list-table"
              rowHeight={46}
              data={props.visits}
              loading={props.loading}
              loadingComponent={<Loading />}
              noRowsMessage={"No visits found."}
            >
              <Column
                key="name"
                dataKey="location"
                width={25}
                label="Unit"
                cellRenderer={nameCellRenderer}
                disableSort={true}
              />
              <Column
                key="entryAt"
                dataKey="entryAt"
                width={45}
                label="Visit Duration"
                cellRenderer={visitCellRenderer}
                disableSort={true}
              />
            </DataTable>
          </div>
          <div className="total-results">
            {props.visits && (
              <div>
                {props.visits.length}{" "}
                {props.visits.length === 1 ? "result" : "results"}
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

EmployeeCaseUserVisitList.propTypes = {
  caseId: PropTypes.string,
  employeeId: PropTypes.string,
  name: PropTypes.string,
  role: PropTypes.string,
  department: PropTypes.string,
  compliance: PropTypes.number,
  modalOpen: PropTypes.bool,
  loading: PropTypes.bool,
  visits: PropTypes.arrayOf(
    PropTypes.shape({
      location: PropTypes.string,
      unit: PropTypes.string,
      entryAt: MomentPropTypes.momentObj,
      duration: PropTypes.number,
    })
  ),
}

EmployeeCaseUserVisitList.defaultProps = {
  caseId: "",
  modalOpen: false,
  visits: [],
}

export default EmployeeCaseUserVisitList
